module.exports = __webpack_public_path__ + "static/assets/945297ca77c041c98377f204e1af772e.svg";